import { unstable_createMuiStrictModeTheme as createMuiTheme } from "@mui/material/styles";

// Cyberpunk-themed color palette inspired by LandingPage.tsx
export const theme = createMuiTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#3b82f6', // Blue-500
      light: '#60a5fa', // Blue-400
      dark: '#2563eb', // Blue-600
    },
    secondary: {
      main: '#a855f7', // Purple-500
      light: '#c084fc', // Purple-400
      dark: '#9333ea', // Purple-600
    },
    error: {
      main: '#ef4444', // Red-500
    },
    warning: {
      main: '#f59e0b', // Amber-500
    },
    success: {
      main: '#10b981', // Green-500
    },
    info: {
      main: '#3b82f6', // Blue-500
    },
    background: {
      default: '#0f172a', // Dark blue-gray (similar to cyberpunk gradient)
      paper: 'rgba(0, 0, 0, 0.7)', // Semi-transparent black
    },
    text: {
      primary: '#e0e7ff', // Light blue
      secondary: '#93c5fd', // Blue-300
    },
  },
  typography: {
    fontFamily: '"Roboto Mono", "Courier New", monospace',
    h1: {
      fontWeight: 700,
      fontSize: '3rem',
    },
    h2: {
      fontWeight: 700,
      fontSize: '2.5rem',
    },
    h3: {
      fontWeight: 700,
      fontSize: '2rem',
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          backdropFilter: 'blur(12px)',
          border: '2px solid rgba(59, 130, 246, 0.5)',
          boxShadow: '0 0 15px rgba(66, 153, 225, 0.5)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontFamily: '"Roboto Mono", monospace',
          fontWeight: 700,
        },
        contained: {
          background: 'linear-gradient(to right, #2563eb, #9333ea)',
          '&:hover': {
            background: 'linear-gradient(to right, #1d4ed8, #7e22ce)',
          },
        },
      },
    },
  },
});